import React from "react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { CommandBar, DefaultButton, IButtonProps, ICommandBarItemProps, IDropdownOption } from "@fluentui/react";
import { Redirect, useHistory } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import { NEED_TO_SUBSCRIBE, DESCRIPTIONS, ANALISIS_CUANTITATIVO_DESCRIPTION } from "./Util/texts";
import Diversificacion from "./Tabs/Diversificacion/Diversificacion";
import AnalisisCuantitativo from "./Tabs/AnalisisCuantitativo/AnalisisCuantitativo";
import Auth from "../../../Auth/Auth";
import SavingsPlanService, { ActiveSubscriptionAndSavingPlans } from "../../../services/SavingsPlanService";
import { TTabType } from "./types/PortfolioTypes";
import Distribucion from "./Tabs/Distribucion/Distribucion";

const BASE_CLASS = "portfolio_file";
const PORTFOLIO_FILE_SUBSCRIPTION_ID = 52;

const PortfolioFile = () =>
{
    const user = useMemo(() => Auth.getUserProfile(), []);
    const activePlan = useSelector((state: RootStateOrAny) => state.auth.userActivePlan);
    const outdated = useMemo<boolean>(() => activePlan?.sync === true && activePlan?.outdated === true, [activePlan]);
    const theme = window.localStorage.getItem("theme") || "light";
    const history = useHistory();
    const [description, setDescription] = useState<string>(ANALISIS_CUANTITATIVO_DESCRIPTION);
    const [options, setOptions] = useState<IDropdownOption[]>([]);
    const [activeTab, setActiveTab] = useState<string>("Analisis cuantitativo");
    const isSubscriptionActive = true;

    const barTabs = useMemo<ICommandBarItemProps[]>(() =>
    [
        {
            text: "Análisis cuantitativo",
            key: "analisis",
            onClick: () => setActiveTab("Analisis cuantitativo"),
            className: activeTab === "Analisis cuantitativo" ? "is-selected" : ""
        },
        {
            text: "Diversificación",
            key: "diversificacion",
            onClick: () => setActiveTab("Diversificacion"),
            className: activeTab === "Diversificacion" ? "is-selected" : ""
        },
        {
            text: "Desglose",
            key: "distribucion",
            onClick: () => setActiveTab("Distribucion"),
            className: activeTab === "Distribucion" ? "is-selected" : ""
        }
    ], [activeTab]);

    const overflowItems: ICommandBarItemProps[] = [];
    const overflowProps: IButtonProps = {ariaLabel: "Más acciones"};

    const fetchPlans = useCallback(async () =>
    {
        if(user?.id === undefined)
        {
            return;
        }
        const result: ActiveSubscriptionAndSavingPlans[] = await SavingsPlanService.getActiveSubscriptionAndSavingPlan(user.id);
        const mappedOptions: IDropdownOption[] = result.map((savingsPlan) =>
        ({
            key: savingsPlan.finametrixContract,
            text: savingsPlan.planName,
            id: savingsPlan.finametrixId.toString()
        }));
        setOptions(mappedOptions);
    }, [user?.id]);

    useEffect(() =>
    {
        setDescription(DESCRIPTIONS[activeTab as TTabType] ?? "");
    }, [activeTab]);

    useEffect(() =>
    {
        fetchPlans();
    }, [fetchPlans]);

    if(!activePlan)
    {
        return null;
    }

    if(outdated === true)
    {
        return <Redirect to="/portfolio" />;
    }

    return(
        <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}__header`}>
                <div className={`${BASE_CLASS}__header__texts`}>
                    <h2>Ficha Cartera</h2>
                    <CommandBar
                        items={barTabs}
                        overflowItems={overflowItems}
                        overflowButtonProps={overflowProps}
                        ariaLabel="Usa las flechas izquierda y derecha para navegar entre las entradas del menú"
                    />
                    <p className={`${BASE_CLASS}__header__description ${theme}`}>
                        {description}
                    </p>
                    {!isSubscriptionActive &&
                    (
                        <p className={`${BASE_CLASS}__header__description alert`}>
                            {NEED_TO_SUBSCRIBE}
                        </p>
                    )}
                </div>
                <div className={`${BASE_CLASS}__header__buttons`}>
                    <DefaultButton className="button tiny-stretch-button" disabled={true} onClick={() => history.push(`/portfolio/service-suscription/${PORTFOLIO_FILE_SUBSCRIPTION_ID}`)}>
                        Suscribirse
                    </DefaultButton>
                </div>
            </div>
            {isSubscriptionActive &&
            (
                <React.Fragment>
                    {activeTab.match("Analisis cuantitativo") &&
                    (
                        <AnalisisCuantitativo activePlan={activePlan} options={options} />
                    )}
                    {activeTab.match("Diversificacion") &&
                    (
                        <Diversificacion activePlan={activePlan} options={options} />
                    )}
                    {activeTab.match("Distribucion") &&
                    (
                        <Distribucion activePlan={activePlan} options={options} />
                    )}
                </React.Fragment>
            )}
        </div>
    );
};

export default PortfolioFile;